import Reflux from "reflux";

const GroupActions = Reflux.createActions([
  "blurGroup",
  "blurGroupEnd",
  "focusGroup",
  "focusGroupEnd",
  "holdFocus",
  "updateGroupData",
]);

export default GroupActions;
